import { useState } from 'react'
import { useBoolean } from 'react-use'

import { safeRowClick } from 'utils/mui-components/data-grid-utils'

import type {
  DataGridProps,
  GridRowParams,
  GridValidRowModel
} from '@mui/x-data-grid'

export function useDrawerControlForDataGrid<T extends GridValidRowModel>() {
  const [isOpen, setIsOpen] = useBoolean(false)
  const [activeItem, setActiveItem] = useState<T | null>(null)

  const handleRowClick: DataGridProps['onRowClick'] = (
    params: GridRowParams<T>,
    event
  ) => {
    safeRowClick(event, () => {
      setActiveItem(params.row)
      setIsOpen(true)
    })
  }

  const handleClose = () => {
    setIsOpen(false)
    setActiveItem(null)
  }

  const handleOpen = (item: T) => {
    setActiveItem(item)
    setIsOpen(true)
  }

  return {
    isOpen,
    activeItem,
    handleRowClick,
    handleClose,
    handleOpen
  }
}
